import {ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output, ViewEncapsulation, TemplateRef, ViewChild, ChangeDetectionStrategy} from "@angular/core";
import {HttpErrorResponse} from "@angular/common/http";
import {UtilityService} from "@irb/irb-common/services/utility.service";
import {IrbSettingsService} from "@irb/irb-settings/irb-settings.service";
import {
  IGlobalSettings,
  IGlobalSettingsSaveResponse,
  IPortfolioCustomCategory
} from "@irb/irb-settings/irb-settings.model";
import {AppService} from "@irb/app.service";
import {IEvent, IrbAppEvents, IrbSettingsEvents} from "@irb-common/events";
import {Observable, of, ReplaySubject, Subscription} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {SettingsPage} from "@irb/irb-settings/irb-settings.page";
import {CalltoactionService} from "@irb/irb-common/components/calltoaction/calltoaction.service";
import {SettingsSecuritesGridLayoutService} from "./settings-securities.grid-layout.service";
import {faDownload} from "@fortawesome/free-solid-svg-icons";
import {ISuggestionView} from "./settings-securities.model";
import {SelectItem} from "primeng/api";
import {DataTransferService} from "@irb/irb-common/services/data-transfer.service";
import {IrbAuthenticationService} from "@irb/irb-authentication/irb-authentication.service";
import {IAlertDialogData, IApplyFilterOnLanding} from '@irb/app.model';
import {IrbAgGridExportService} from "@irb/irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-grid-export/irb-ag-grid-export.service";
import {MatDialogRef} from '@angular/material/dialog';
import {SettingsDialogComponent} from '@irb/irb-settings/settings-dialog/settings-dialog.component';
import {Router} from "@angular/router";
import {AnalyticsService} from "@irb-common/analytics/analytics.service";
import { IrbDialogsEvents } from '@irb/irb-dialogs/irb-dialogs.events';

@Component({ standalone: false,
  selector: "irb-settings-securities",
  templateUrl: "./settings-securities.component.html",
  styleUrls: ["./settings-securities.component.scss", "../../irb-common/styles/dialog.scss"],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class SettingsSecuritiesComponent implements SettingsPage<IGlobalSettings>, OnInit, OnDestroy {
  _globalSettings: IGlobalSettings;
  originalGlobalSettings: IGlobalSettings;
  private _securityCustomCategories: Array<any> = [];
  _originalSecurityCustomCategories: Array<any>;
  newSecurityCustLabelAbbr: string;
  newSecurityCustLabelDesc: string;
  grid: any;
  gridOptions: any;
  frameworkComponents: any;
  footerContent: string;
  _isModified: boolean;
  eventSubscription: Subscription;
  securitiesExisting: string;
  morningStarCatAutoMapCurrent: boolean;
  uncategorizedSecurities: string;
  allSecurities: string;
  showUnsavedChangesWarning: boolean = false;
  cashSettingsPlaceholder = "";
  newSecurityCustLabelAbbrExists: boolean = false;
  faDownload = faDownload;
  _targetSuggestionValues: any;
  originalTargetSuggestionValues: any;
  rightTargetData: Array<SelectItem>;
  leftSourceData: Array<SelectItem>;
  isCustomaCategoryAvailable: boolean = false;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  filterText: string = "";
  catIds: Array<any> = [];
  singleVCatIDs: number[];
  customCategory: string = "CustCat";
  isadmin: boolean = false;
  deleteEventFired: boolean = false;
  isImpSecJobSubToday:boolean = true;
  @Output()
  closeModal: EventEmitter<any> = new EventEmitter<any>();
  isUiTest = false;
  defaultExpandedPanels:Array<string> = ["HISTORY","SCHWAB_SEC_CLASS","CUSTOM_SEC_CLASS","IMPORT_SEC"];
  isNewSecurityCustLabelAbbrRequired: boolean = false;
  showClassificationColumnEdit: boolean = false;
  morningstarValuesModified: boolean = false;
  morningstarValuesStaged: boolean = false;

  /*validation*/
  labelNamesRegExp: string;
  validationErrors: string[];
  validationErrorTemplates: TemplateRef<any>[];
  @ViewChild("columnNameValidationErrorTemplate") columnNameValidationErrorTemplate: TemplateRef<any>;
  @ViewChild("labelNameValidationErrorTemplate") labelNameValidationErrorTemplate: TemplateRef<any>;
  @ViewChild("labelNameExistsValidationErrorTemplate") labelNameExistsValidationErrorTemplate: TemplateRef<any>;
  @ViewChild("labelNameInvalidCharValidationErrorTemplate") labelNameInvalidCharValidationErrorTemplate: TemplateRef<any>;
  @ViewChild("labelNameGridValidationErrorTemplate") labelNameGridValidationErrorTemplate: TemplateRef<any>;
  @ViewChild("labelNameInput") labelNameInput: any;
  @ViewChild("labelDescriptionInput") labelDescriptionInput: any;
  @ViewChild("columnNameInput") columnNameInput: any;
  custCatPanelExpanded: boolean = true;
  ENABLE_SETTINGS_HIST = false;

  constructor(
    public iss: IrbSettingsService, 
    private cdr: ChangeDetectorRef, 
    private util: UtilityService, 
    private as: AppService, 
    private ssgls: SettingsSecuritesGridLayoutService,
    private ctas: CalltoactionService, 
    public dataTransferService: DataTransferService, 
    public ias: IrbAuthenticationService, 
    public ges: IrbAgGridExportService,
              public dialogRef: MatDialogRef<SettingsDialogComponent>,
              private router: Router,
    public ats: AnalyticsService
  ) {
    this.ats.trackGlobalSettingsSecuritiesEvent();
    this.ENABLE_SETTINGS_HIST = this.as.getItem('IRB_APP_CONFIG')?.featureFlags?.ENABLE_SETTINGS_HIST || false;
    this.eventSubscription = this.as.getEvents().subscribe((s) => {
      this.processEvent(s);
    });
  }

  ngOnInit() {
    this.iss.getGlobalSettings().pipe(takeUntil(this.destroyed$)).subscribe((data: IGlobalSettings) => {
      this.globalSettings = data;
      this.globalSettings.bulkCustCatAddFlag = false;
      this.globalSettings.bulkMstarCatDeleteFlag = false;
      this.globalSettings.bulkCustCatDeleteFlag = false;
      this.isadmin = this.globalSettings.isAdminUser;
      if (!this.ENABLE_SETTINGS_HIST) {
        this.defaultExpandedPanels = this.defaultExpandedPanels.filter(p => p !== 'HISTORY');
      }
      this.iss.loadExpansionState(this.defaultExpandedPanels.length, "settings-securities", this.defaultExpandedPanels);
      if (this.ENABLE_SETTINGS_HIST) {
        this.iss.updateExpansionState('HISTORY','closed');
      }
      this.gridOptions = {
        columnDefs: this.ssgls.getColumnDefs(this),            
        floatingFilter: false,
        overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No Custom values defined.</span>",
        context: { componentParent: this },
        suppressHorizontalScroll: true
      };
      
      this.frameworkComponents = this.ssgls.getFrameworkComponents();
      this.custCatPanelExpanded = this.iss.getDefaultExpansionState('CUSTOM_SEC_CLASS');
      this.cdr.detectChanges();
    });
    
    this.getSuggestions();
    const dialogData: any = this.iss.getDialogData();

    if (dialogData && dialogData.dropdownSearchValue) {
      this.newSecurityCustLabelAbbr = dialogData.dropdownSearchValue;
    }

    this.checkIsImpSecJobSubToday();
    this.cdr.detectChanges();
    
  }

  ngOnDestroy() {
    this.eventSubscription.unsubscribe();
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onGridReady(params: any) {
    this.grid = params;
    this.morningStarCatAutoMapCurrent = this.globalSettings.morningStarCatAutoMap !== null;
    this.loadGrid(false);
    this.load(this.globalSettings as IGlobalSettings);
    this.dataTransferService.EnvironmentSpecificCustomCategory = this.globalSettings.securityCustAttrAbbr;
    this.customCategory = this.globalSettings.securityCustAttrAbbr;
  }

  onGridChange(event: any) {
    let msg: string;
    const cc = {
      valueLabel: event.data.valueLabel,
      categoryName: event.data.categoryName,
      categoryId: event.data.categoryId,
      isSecurityPage: true,
      globalSettingsId: this.globalSettings.globalSettingsId,
      environmentId: this.globalSettings.environmentId,
    } as IPortfolioCustomCategory;

    if(this.checkIfSecurityCustLabelAbbrExists(cc.valueLabel, cc.categoryId)) {
      msg = cc.valueLabel + " is already in use."
    } else if(cc.valueLabel.length == 0) {
      msg = "The 'Category Name' field cannot be empty";
    } else {
      this.globalSettings.newCustCatagList = this.globalSettings.newCustCatagList.filter((x: any) => x.categoryId != cc.categoryId);
        this.globalSettings.newCustCatagList.push(cc);

      this.onInputChange();
      this.updateGrid();
      return;
    }

      this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
        dType: "ERROR",
        altMsgHTML: msg,
        onProceed: () => {
          this.revertGrid();
        }
    } as IAlertDialogData);
  }

  onInputChange() {
    window.setTimeout(() => {
      this.isModified = !this.util.compare(this.originalGlobalSettings, this.globalSettings);
      this.as.fireEvent(this.isModified ? IrbSettingsEvents.IS_MODIFIED : IrbSettingsEvents.IS_NOT_MODIFIED);
      this.showUnsavedChangesWarning = false;
      this.validateInput().subscribe(_validationErrors => {});
    });
  }

  validateInput(): Observable<string[]> {
    this.validationErrors= new Array<string>();
    this.validationErrorTemplates = [];

    if(this.columnNameInput?.inputControl.invalid) {
      this.validationErrors.push("");
      this.validationErrorTemplates.push(this.columnNameValidationErrorTemplate);
    }

    let gridErrors = this.securityCustomCategories?.filter((x: any) => 
        x.valueLabel?.includes("^") || 
        x.valueLabel?.length == 0 || 
        x.valueLabel?.length > 25 ||     
        x.categoryName?.length > 50 || 
        (x.valueLabel?.length > 0 && "+-=@".includes(x.valueLabel?.charAt(0))) || 
        (x.categoryName?.length > 0 && "+-=@".includes(x.categoryName?.charAt(0)))
    );
	  
    if(gridErrors?.length > 0) {
      this.validationErrors.push("");
      this.validationErrorTemplates.push(this.labelNameGridValidationErrorTemplate);
    }

    this.cdr.detectChanges();
    return of(this.validationErrors);
  }

  load(data: IGlobalSettings) {
    this.globalSettings = data;
    this.globalSettings.bulkCustCatAddFlag = false;
    this.globalSettings.bulkMstarCatDeleteFlag = false;
    this.globalSettings.bulkCustCatDeleteFlag = false;
    this.globalSettings.currentSetting = "securityView";
    this.globalSettings.newCustCatagList = [];
    this.globalSettings.deletedCustCatagList = [];
    if (this.morningStarCatAutoMapCurrent === true && !this.globalSettings?.morningStarCatAutoMap) {
      this.globalSettings.morningStarCatAutoMap = "ApplyToNewSecuritiesOnly";
    }
    this.originalGlobalSettings = this.util.clone(this.globalSettings);
    this.isModified = false;
    this.showUnsavedChangesWarning = false;
    this.as.fireEvent(IrbSettingsEvents.IS_NOT_MODIFIED);
    this.updateGridFooter();
  }

  loadGrid(isAfterSave: boolean) {
    this.iss
      .getSecurityCustCategorySettings()
      .subscribe((data: Array<IPortfolioCustomCategory>) => {
        this.securityCustomCategories = data;
        this.originalSecurityCustomCategories = this.util.clone(this.securityCustomCategories);
        this.updateGrid();
        this.updateInuseSuggestions();
        if (isAfterSave) {
          this.as.fireEvent(IrbSettingsEvents.SAVE_SUCCESS, "Security settings were updated.");
          this.triggerNewItemToDropdown();
        }
      });
  }

  updateGrid() {
      if (this.grid && this.grid.api) {
          this.grid.api.setGridOption('rowData', this.securityCustomCategories);
          this.updateGridFooter();
      }
  }

  updateGridFooter() {
      if (this.globalSettings && this.grid && this.grid.api) {
      this.footerContent = this.grid.api.getDisplayedRowCount() + " Categories";
    }
  }

  save() {
    this.deleteEventFired = false;
    if (this.morningStarCatAutoMapCurrent === true) {
      this.as.fireEvent(IrbSettingsEvents.SECURITY_EXISTING, this.globalSettings.morningStarCatAutoMap);
      this.showMorningStarDialog();
    } else {
      this.globalSettings.morningStarCatAutoMap = null;
      this.savewithoutMorningStart();
    }
  }

  showMorningStarDialog() {
    const crConfig = {
      parentComponent: "com-morningstar-category",
      parentComponentThis: this,
      allowRebalanceSubmit: false,
    };
    this.as.fireEvent("MorningstarCategoriesAutomaticMapping", crConfig);
    this.as.fireEvent(IrbSettingsEvents.SECURITY_EXISTING, this.globalSettings.morningStarCatAutoMap);
  }

  savewithoutMorningStart() {
    this.as.fireEvent(IrbSettingsEvents.SAVE_START);
    const dialogData: any = this.iss.getDialogData() || {};
    this.globalSettings.bulkCustCatDeleteFlag = false;
    if (this.globalSettings.deletedCustCatagList?.length && this.isCategoriesEmpty) {
      this.globalSettings.bulkCustCatDeleteFlag = true;
    }
    this.iss.saveSecurityAndPortfolioGlobalSettings(this.globalSettings).subscribe(
      (data: any) => {
        const response = data as IGlobalSettingsSaveResponse;
        if (response.responseStatus === "SUCCESS") {
          if (response.responseUtilityMap != null) {
            //TODO: Show validation warning
          } else {
            this.iss
              .getGlobalSettings()
              .subscribe((data: any) => {
                this.loadGrid(true);
                this.load(data as IGlobalSettings);
                if (!dialogData.dropdownSearch) {
                  this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
                }
                this.dataTransferService.EnvironmentSpecificCustomCategory = this.globalSettings.securityCustAttrAbbr;
                this.customCategory = this.globalSettings.securityCustAttrAbbr;
              });
          }
        } else {
          this.as.fireEvent(IrbSettingsEvents.SAVE_ERROR);
        }
      },
      (_err: HttpErrorResponse) => {
        this.as.fireEvent(IrbSettingsEvents.SAVE_ERROR);
      }
    );
  }

  revert() {
    if (this.isModified) {
      this.load(this.originalGlobalSettings);
    }
  }

  revertGrid() {
    this.securityCustomCategories = this.util.clone(this.originalSecurityCustomCategories);
    this.updateGrid();
  }

  processEvent(event: IEvent) {
    switch (event.type) {
      case IrbSettingsEvents.SAVE:
        this.save();
        break;
      case IrbSettingsEvents.UNSAVED_CHANGES:
        if (this.isModified) {
          this.showUnsavedChangesWarning = true;
        }
        break;
      case IrbSettingsEvents.REVERT_CHANGES:
        this.revert();
        break;
      case IrbSettingsEvents.DELETE_ASSET_CATEGORY:
        this.deleteAllCategoryMenuItems();
        break;
      case IrbSettingsEvents.DELETE_ASSET_CATEGORY_SINGLE:
        this.deleteCategoryDialog(event.data);
        break;
      case IrbSettingsEvents.DELETE_ASSET_REMOVE_ALL:
        this.btnRemoveAll();
        break;
      case IrbSettingsEvents.SAVE_WITHOUT_MORNING_STAR:
        this.savewithoutMorningStart();
        break;
    }
  }

  addCategoryMenuItem() {
    this.isNewSecurityCustLabelAbbrRequired = true;
    this.newSecurityCustLabelAbbr = this.newSecurityCustLabelAbbr?.trim() || "";
    this.newSecurityCustLabelDesc = this.newSecurityCustLabelDesc?.trim() || "";
    this.newSecurityCustLabelAbbrExists = this.checkIfSecurityCustLabelAbbrExists(this.newSecurityCustLabelAbbr);

    if(this.newSecurityCustLabelAbbrExists) {
      let a = this.securityCustomCategories.map(a => a.valueLabel);
      this.labelNamesRegExp = "^(?!(" + a.join("|") + ")$).*$";
    }

    if(this.validateCategoryMenuItem()) {
      this.isNewSecurityCustLabelAbbrRequired = false;

    const cc = {
      valueLabel: this.newSecurityCustLabelAbbr,
      categoryName: this.newSecurityCustLabelDesc,
      isSecurityPage: true,
      globalSettingsId: this.globalSettings.globalSettingsId,
      environmentId: this.globalSettings.environmentId,
      categoryId: new Date().getTime() * -1,
      isCustomEntry: true
    } as IPortfolioCustomCategory;

    this.globalSettings.newCustCatagList.push(cc);
    this.securityCustomCategories.push(cc);

    this.onInputChange();
    this.updateGrid();

    const dialogData: any = this.iss.getDialogData();
    if (dialogData) {
      dialogData.dropdownSearchValue = this.newSecurityCustLabelAbbr;
      this.iss.setDialogData(dialogData);
    }

    this.newSecurityCustLabelAbbr = null;
    this.newSecurityCustLabelDesc = null;
      this.cdr.detectChanges();
    }
  }

  removeFromNewList(cc: IPortfolioCustomCategory) {
    for (let i = 0; i < this.globalSettings.newCustCatagList.length; i++) {
      if (this.globalSettings.newCustCatagList[i].categoryId === cc.categoryId) {
        this.globalSettings.newCustCatagList.splice(i, 1);
        break;
      }
    }
  }

  cancelDelete() {
    this.ctas.remove();
  }

  disableDelete(params: any) {
    if (!this.isadmin) {
      return false;
    } else {
      if (params.data.valueLabel.toUpperCase() === "CASH" || params.data.valueLabel.toUpperCase() === "OTHER") {
        return false;
      } else {
        return true;
      }
    }
  }

  deleteCategoryMenuItem(cc: any) {
    for (let i = 0; i < this.securityCustomCategories.length; i++) {
      if (this.securityCustomCategories[i].categoryId === cc.categoryId) {
        this.securityCustomCategories.splice(i, 1);
        break;
      }
    }
    if (cc.categoryId > 0) {
      this.globalSettings.deletedCustCatagList.push(cc);
    } else {
      this.removeFromNewList(cc);
    }
    this.onInputChange();
    this.updateGrid();
  }

  deleteCategoryDialog(cc: any) {
    for (let i = 0; i < this.securityCustomCategories.length; i++) {
      if (this.securityCustomCategories[i].categoryId === cc.categoryId) {
        this.securityCustomCategories.splice(i, 1);
        break;
      }
    }
    if (cc.categoryId > 0) {
      this.globalSettings.deletedCustCatagList.push(cc);
    } else {
      this.removeFromNewList(cc);
    }
    this.onInputChange();
    this.updateGrid();
  }
  
  checkDeleteCategory(cc: any) {
    this.ctas.remove();
    this.catIds = [];
    for (let i = 0; i < this.securityCustomCategories.length; i++) {
      if (this.securityCustomCategories[i].categoryId === cc.categoryId) {
        this.catIds.push(cc.categoryId);
        this.iss.checkCategoryRestrictions([cc.categoryId]).subscribe((data: any) => {
          if (data.responseData == null || data.responseData.length === 0) {
            this.deleteCategoryMenuItem(cc);
          } else {
            this.showDeleteAssetCategoryDialog();
          }
        });
        break;
      }
    }
  }
  deleteAllCategoryMenuItems() {
    const notDeleted = [];
    for (let i = 0; i < this.securityCustomCategories.length; i++) {
      const hasCategoryId = this.securityCustomCategories[i].categoryId > 0;
      const isCash = this.securityCustomCategories[i].valueLabel.toUpperCase() === "CASH";
      const isOther = this.securityCustomCategories[i].valueLabel.toUpperCase() === "OTHER";

      if (hasCategoryId && !isCash && !isOther) {
        this.globalSettings.deletedCustCatagList.push(this.securityCustomCategories[i]);
      } else if (isCash || isOther) {
        notDeleted.push(this.securityCustomCategories[i]);
      }
    }
    this.globalSettings.newCustCatagList = [];
    this.securityCustomCategories = notDeleted;
    this.deleteEventFired = true;
    this.onInputChange();
    this.updateGrid();
  }

  checkCategoryRestrictions() {
    this.ctas.remove();
    this.catIds = [];

    for (let i = 0; i < this.securityCustomCategories.length; i++) {
      this.catIds.push(this.securityCustomCategories[i].categoryId);
    }

    this.iss
      .checkCategoryRestrictions(this.catIds)
      .subscribe((data: any) => {
        if (data.responseData == null || data.responseData.length === 0) {
          this.deleteAllCategoryMenuItems();
        } else {
          this.showDeleteAssetCategoryDialog();
        }
      });
  }

  showDeleteAssetCategoryDialog(cbFunc?: Function) {
    this.as.fireEvent(IrbSettingsEvents.SHOW_DELETE_ASSET_CATEGORY, {
      catIds: this.catIds,
      cbFunc: cbFunc,
    });
  }

  onNewSecurityCustLabelAbbrChange() {
    this.newSecurityCustLabelAbbrExists = false;
    this.labelNamesRegExp = null;
    this.validateCategoryMenuItem();
  }

  validateCategoryMenuItem(): boolean {
    this.validationErrorTemplates = [];

    if((!this.newSecurityCustLabelAbbr || this.newSecurityCustLabelAbbr?.length == 0) && this.isNewSecurityCustLabelAbbrRequired) {
      this.validationErrorTemplates.push(this.labelNameValidationErrorTemplate);
      return false;
    }

    if(this.newSecurityCustLabelAbbrExists) {
      this.validationErrorTemplates.push(this.labelNameExistsValidationErrorTemplate);
      return false;
    }

    if(this.newSecurityCustLabelAbbr?.includes("^")) {
      this.validationErrorTemplates.push(this.labelNameInvalidCharValidationErrorTemplate);
      return false;
    }

    return true;
  }

  checkIfSecurityCustLabelAbbrExists(s: string, id?: number): boolean {
    let b = false;

    this.securityCustomCategories.forEach((cc) => {
      if (cc.valueLabel.toLowerCase() === s?.toLowerCase() && !id) {
        b = true;
      } else if (cc.valueLabel.toLowerCase() === s?.toLowerCase() && id && cc.categoryId !== id) {
        b = true;
      }
    });

    return b;
  }

  checkIfSecurityCustLabelAbbrChanged(s: string, id: number): boolean {
    let b = false;
    s = s || null;

    this.originalSecurityCustomCategories.forEach((cc) => {
      if (cc.valueLabel !== s && cc.categoryId === id) {
        b = true;
      }
    });

    return b;
  }

  checkIfSecurityCustDescriptionChanged(s: string, id: number): boolean {
    let b = false;
    s = s || null;

    this.originalSecurityCustomCategories.forEach((cc) => {
      if (cc.categoryName !== s && cc.categoryId === id) {
        b = true;
      }
    });

    return b;
  }

  export() {
    //const sortModel = this.grid.api.getSortModel();
    let sortModel: any = [];
    let columnWithSort = this.grid.api.getColumnState().filter((col:any) => col.sort !== null);
    if (columnWithSort) {
      sortModel = columnWithSort;
    }
    let originalSecurityCustomCategories: any[] = [];
    if(this.originalSecurityCustomCategories && this.originalSecurityCustomCategories.length > 0) {
      originalSecurityCustomCategories = this.util.clone(this.originalSecurityCustomCategories);
    }
    for (let i = 0; i < sortModel.length; i++) {
      originalSecurityCustomCategories.sort(function (a: any, b: any) {
        const x = sortModel[i].sort === "asc" ? a[sortModel[i].colId] : b[sortModel[i].colId];
        const y = sortModel[i].sort === "asc" ? b[sortModel[i].colId] : a[sortModel[i].colId];
        if (typeof x === "string" && typeof y === "string") {
          return x.toLowerCase() < y.toLowerCase() ? -1 : x.toLowerCase() > y.toLowerCase() ? 1 : 0;
        } else if (typeof x === "number" && typeof y === "number") {
          return x - y;
        } else if (x === null) {
          return sortModel[i].sort === "asc" ? -1 : 1;
        } else if (y === null) {
          return sortModel[i].sort === "asc" ? 1 : -1;
        }
      });
    }

    let columnHeader: any = ['Name', 'Description', 'In # Secs'].join(",") + "\n";
    let exportPayload = columnHeader;

     originalSecurityCustomCategories.forEach((item: any)=>{
       let exportItem:any = [this.util.encodeForCSV(item.valueLabel), this.util.encodeForCSV(item.categoryName), item.customSecurityCount].join(",") + "\n";
       exportPayload+=exportItem;
      });

    this.ges.setPrefix("Security_custom_category_settings", "csv");
    const blob = new Blob([exportPayload]);
    this.ges.download(blob);
  }

  getRowCount() {
    return this.securityCustomCategories.length;
  }

  get globalSettings() {
    return this._globalSettings;
  }

  set globalSettings(newGlobalSettings: IGlobalSettings) {
    this._globalSettings = newGlobalSettings;
  }

  get isModified() {
    return this._isModified;
  }

  set isModified(newIsModified: boolean) {
    this._isModified = newIsModified;
  }

  get addButtonDisabledTooltip() {
    return "Type a description for a new " + this.globalSettings.portfolioCustLabelDesc;
  }

  public get securityCustomCategories(): Array<IPortfolioCustomCategory> {
    return this._securityCustomCategories;
  }

  public set securityCustomCategories(value: Array<IPortfolioCustomCategory>) {
    this._securityCustomCategories = value;
  }

  get isCategoriesEmpty(): boolean {
    return !this._securityCustomCategories?.length ||
      this._securityCustomCategories.every(c => {
        const label = c.valueLabel?.toUpperCase();
        return label === 'CASH' || label === 'OTHER';
      });
  }

  saveSuggestedCustomValues() {
      this.targetSuggestionValues.filter((element) => {
        if (element.isAdded === false) {
          this.securityCustomCategories.filter((securityItemsRemove, index1, arr1) => {
            if (securityItemsRemove.categoryName === element.categoryName) {
              this.globalSettings.deletedCustCatagList.push(securityItemsRemove);
              arr1.splice(index1, 1);
            }
          });
      } else if (element.isAdded === true) {
          const checkRecord = this.securityCustomCategories.filter((securityItemsAdd) => {
            return securityItemsAdd.categoryName === element.categoryName;
          });
          if (checkRecord.length === 0) {
            const cc = {
              valueLabel: element.valueLabel,
              categoryName: element.categoryName,
              isSecurityPage: true,
              globalSettingsId: this.globalSettings.globalSettingsId,
              environmentId: this.globalSettings.environmentId,
              isAdded: true,
              isCustomEntry: false,
              isRemoved: false,
              categoryId: new Date().getTime() * -1,
            } as IPortfolioCustomCategory;
            this.globalSettings.newCustCatagList.push(cc);
            this.securityCustomCategories.push(cc);
          }
        }
        this.globalSettings.bulkCustCatAddFlag = false;
        this.globalSettings.bulkMstarCatDeleteFlag = false;
        if (this.globalSettings.newCustCatagList?.length >=this.leftSourceData?.length + this.rightTargetData?.length) {
          this.globalSettings.bulkCustCatAddFlag = true;
        }
        if (this.globalSettings.deletedCustCatagList?.length >=this.leftSourceData?.length + this.rightTargetData?.length) {
          this.globalSettings.bulkMstarCatDeleteFlag = true;
        }
      });

      this.onInputChange();
      this.updateGrid();
      this.deleteEventFired = false;
      this.morningstarValuesStaged = false;
      this.morningstarValuesModified = this.globalSettings.deletedCustCatagList?.length > 0 || this.globalSettings.newCustCatagList?.length > 0;
      this.cdr.detectChanges();
  }

  revertSuggestedCustomValues() {
    this.globalSettings.deletedCustCatagList = [];
    this.globalSettings.newCustCatagList = [];
    this.targetSuggestionValues = this.util.clone(this.originalTargetSuggestionValues);
    this.morningstarValuesStaged = false;
    this.morningstarValuesModified = false;
    this.updateInuseSuggestions();
    this.updateAvailable();
    this.updateInUse();
    this.onInputChange();            
    this.globalSettings.bulkCustCatAddFlag = false;
    this.globalSettings.bulkMstarCatDeleteFlag = false;
  }

  getSuggestions() {
    this.targetSuggestionValues = [];
    this.rightTargetData = [];
    this.leftSourceData = [];

    this.iss
      .getViewSuggestionValues()
      .subscribe((data: any) => {
        for (let i = 0; i < data.suggestionValues.length; i++) {
          if (data.suggestionValues[i].valueLabel !== "Other" && data.suggestionValues[i].valueLabel !== "Cash") {
            this.targetSuggestionValues.push(data.suggestionValues[i]);
          }
        }
        
        this.updateInuseSuggestions();
        this.originalTargetSuggestionValues = this.util.clone(this.targetSuggestionValues);
      });
  }

  suggestionAddOrRemove(queryObj: any, value: Array<any>, flagAddorRemove: any) {
    let suggestRemove: any;

    if (queryObj === "valueLabel") {
      suggestRemove = this.targetSuggestionValues.filter((element) => value.indexOf(element.categoryName) !== -1);
    }

    if (queryObj === "isAdded") {
      suggestRemove = this.targetSuggestionValues.filter((element) => value.indexOf(element.isAdded) !== -1);
    }

    if (suggestRemove.length) {
      suggestRemove.forEach((element: any) => {
        if (flagAddorRemove) {
          const isFilterMatch = this.filterText.length > 0 ? element.categoryName.toUpperCase().includes(this.filterText.toUpperCase()) : true;
          if (isFilterMatch) {
            element.isAdded = true;
          }
        } else {
          element.isAdded = false;
        }
      });

      this.updateInUse();
    } 
    
    this.updateAvailable();
  }

  updateInuseSuggestions() {
    const updateInuseSuggestions = this.targetSuggestionValues.filter((element) => element.isAdded === true);
    updateInuseSuggestions.forEach((element) => {
      element.isAdded = false;
    });

    for (let j = 0; j < this.securityCustomCategories.length; j++) {
      const items = this.securityCustomCategories[j];
      if (items.isCustomEntry === false) {
        this.suggestionAddOrRemove("valueLabel", [items.categoryName], true);
      }
    }
  }

  updateAvailable() {
    this.leftSourceData = [];
    this.targetSuggestionValues.sort((a, b) => a.categoryName.localeCompare(b.categoryName));
    this.targetSuggestionValues.forEach((element) => {
      const isFilterMatch = this.filterText.length > 0 ? element.categoryName.toUpperCase().includes(this.filterText.toUpperCase()) : true;
      
      if (element.isAdded === false && isFilterMatch) {
        this.leftSourceData.push({
          label: element.categoryName,
          value: element.categoryName,
        });
      }
    });
  }

  updateInUse() {
    this.rightTargetData = [];
    this.targetSuggestionValues.sort((a, b) => a.categoryName.localeCompare(b.categoryName));
    this.targetSuggestionValues.forEach((element) => {
      if (element.isAdded === true) {
        this.rightTargetData.push({
          label: element.categoryName,
          value: element.categoryName,
        });
      }
    });
  }

  updateOptions() {
    //Move all items to
    if (this.morningStarCatAutoMapCurrent === false) {
      this.globalSettings.morningStarCatAutoMap = null;
    } else if (this.morningStarCatAutoMapCurrent === true) {
      this.globalSettings.morningStarCatAutoMap = "ApplyToNewSecuritiesOnly";
    }
    this.btnAddAll();
    this.saveSuggestedCustomValues();
    this.onInputChange();
  }

  btnAdd(event: any) {
    if (event) {
      this.suggestionAddOrRemove("valueLabel", event, true);
      this.morningstarValuesStaged = true;
    }
  }

  btnRemove(event: any) {
    this.catIds = [];

    for (let i = 0; i < this.securityCustomCategories.length; i++) {
      if (this.securityCustomCategories[i].categoryName === event[0]) {
        this.catIds = [this.securityCustomCategories[i].categoryId];
        break;
      }
    }

    this.checkForCategoryRestrictionWarning(this.catIds, () => {
      this.suggestionAddOrRemove("valueLabel", event, false);
    });

    this.morningstarValuesStaged = true;
  }

  btnRemoveAll() {
    this.catIds = [];

    for (let i = 0; i < this.securityCustomCategories.length; i++) {
      for (let ii = 0; ii < this.targetSuggestionValues.length; ii++) {
        if (this.securityCustomCategories[i].valueLabel === this.targetSuggestionValues[ii].valueLabel) {
          this.catIds.push(this.securityCustomCategories[i].categoryId);
          break;
        }
      }
    }

    this.checkForCategoryRestrictionWarning(this.catIds, () => {
      this.suggestionAddOrRemove("isAdded", [true], false);
      this.updateAvailable();
    });

    this.morningstarValuesStaged = true;
  }

  checkForCategoryRestrictionWarning(catIds: Array<number>, cbFunc: Function) {
    if (catIds.length > 0) {
      this.iss.checkCategoryRestrictions(catIds).subscribe((data: any) => {
        if (data.responseData == null || data.responseData.length === 0) {
          cbFunc();
        } else {
          this.showDeleteAssetCategoryDialog(cbFunc);
        }
      });
    } else {
      cbFunc();
    }
  }

  btnAddAll() {
    this.suggestionAddOrRemove("isAdded", [false], true);
    this.morningstarValuesStaged = true;
  }

  applyFilter(s: string) {
    this.filterText = s;
    this.updateAvailable();
  }

  get targetSuggestionValues(): Array<ISuggestionView> {
    return this._targetSuggestionValues;
  }

  set targetSuggestionValues(newtargetSuggestionValues: Array<ISuggestionView>) {
    this._targetSuggestionValues = newtargetSuggestionValues;
  }

  get originalSecurityCustomCategories(): Array<any> {
    return this._originalSecurityCustomCategories;
  }

  set originalSecurityCustomCategories(n: Array<any>) {
    this._originalSecurityCustomCategories = n;
  }

  triggerNewItemToDropdown() {
    const dialogData: any = this.iss.getDialogData();
    if (dialogData && dialogData.dropdownSearchValue) {
      const newItem: any = this.securityCustomCategories.filter((ctgr: any) => {
        return ctgr.valueLabel === dialogData.dropdownSearchValue;
      });
      if (newItem && newItem.length !== 0) {
        const newCat: any = [{
          custCatId: newItem[0].categoryId,
          custCatName: newItem[0].valueLabel,
          custCatDesc: newItem[0].categoryName
        }];
        dialogData.newItems = newCat;
        const newCatDD: any = [{
          name: newItem[0].valueLabel,
          value: newItem[0].categoryId
        }];
        dialogData.newItemsForDD = newCatDD;
      }
      this.as.fireEvent(IrbSettingsEvents.ASSET_CATEGORY_UPDATED, dialogData);
      this.dialogRef.close();
    }
  }
  showSecurityDetails(data: any) {
    const state: IApplyFilterOnLanding = {
      isUpdatRequired: true,
      filterModel:
          { name: 'customCategoryName', value: data.valueLabel,isUpdatRequired: true}
    } as IApplyFilterOnLanding;
    this.as.fireEvent(IrbSettingsEvents.SHOW_SECURITIES_BY_CATEGORY,state);
    this.router.navigateByUrl('/models/security-master', { state: state });
    this.closeModal.next(true);
  }

  checkIsImpSecJobSubToday(){
    this.iss.disableImportSecJobButton().subscribe((data: any) => {
      if(data.responseUtilityMap != null ){
        this.isImpSecJobSubToday = data.responseUtilityMap.isJobSubmittedToday;
      }
    });
  }

  invokeImportSecuritiesJob() {
      this.iss.importSecurities().subscribe((data: any) => {
        if (data.responseStatus === "EXCEPTION") {
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'error',
            summary: 'Import Failed',
            detail: "Please contact the support team at...",
            life: 5000
        });
        this.isImpSecJobSubToday = true;
        } else if (data.responseStatus === "SUCCESS"){
          this.isImpSecJobSubToday = false;
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'success',
            summary: 'Import Submitted',
            detail: "You can continue using iRebal while the import is processing",
            life:5000
        });
        this.isImpSecJobSubToday = true;
        } else if (data.responseStatus === "BUSINESS_ERR_MSG"){
          this.isImpSecJobSubToday = false;
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'warn',
            summary: 'Import Cannot Be Submitted',
            detail: "An import has already been submitted today. The import can only be run once per day",
            life:5000
        });
        this.isImpSecJobSubToday = true;
        }
      });
      this.as.fireEvent(IrbSettingsEvents.SHOW_IMPORT_SEC_JOB_STATUS);
    }
  
    focusLabelNameInput() {
      this.labelNameInput.inputField.nativeElement.focus();
    }
  
    focusColumnNameInput() {
      this.columnNameInput.inputField.nativeElement.focus();
    }

    focusLabelDescriptionInput() {
      this.labelDescriptionInput.inputField.nativeElement.focus();
    }

    openSecurityMaster() {
      this.as.fireEvent(IrbSettingsEvents.NAVIGATE, {url: "/models/security-master"});
    }

    toggleClassificationColumnEdit() {
      this.showClassificationColumnEdit = !this.showClassificationColumnEdit;
    }

    revertClassificationColumnEdit() {
      this.globalSettings.securityCustAttrAbbr = this.originalGlobalSettings.securityCustAttrAbbr;
      this.globalSettings.securityCustAttrDesc = this.originalGlobalSettings.securityCustAttrDesc;
      this.toggleClassificationColumnEdit();
      this.onInputChange();
    }

    showViewAssetClassesDialog() {
       this.as.fireEvent(IrbDialogsEvents.SHOW_VIEW_ASSET_CLASSES_DIALOG);
    }
}
